import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=35298519&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "styles/components/navbar.css?vue&type=style&index=0&id=35298519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35298519",
  null
  
)

export default component.exports